import styled from 'styled-components'
import { animated } from 'react-spring'

export const Accordion = styled(animated.div)`
	border: none;
	overflow: hidden;
	position: relative;
	border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
`

export const HeadingContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-content: center;
	margin-top: 1rem;
	margin-bottom: 1rem;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
`

export const ExpandButton = styled(animated.button)`
	background: transparent;
	border: none;
	height: 5rem;
	width: 5rem;
	cursor: pointer;

	svg path {
		transition: stroke 200ms;
	}

	&:hover {
		svg path {
			stroke: ${({ theme }) => theme.colors.secondary};
		}
	}
`

export const Content = styled.div`
	padding-top: 0.3125rem;
	min-width: 3.125rem;
	display: flex;
	flex-direction: column;
`
